import React ,  { useState , useEffect } from 'react'
import DoCaseCard00 from './DoCaseCard00'

import axios from 'axios'




function DoCase00( { setSelected  , theCards  , theCode}) { // Se pasa el objeto seleccionado

const [cards,setCards] = useState( [])
const [lastCode,setlastCode] = useState( "") ; // Este es el ultimo codigo que enviamos




useEffect(() => {

    loadCatCodigos() ; // Se carga al inicio

},[])

function loadCatCodigos()
  {
    axios.get(  "http://localhost:3004/livefactura/getCaseSatCodigo" ) // 300 , 400 etc
    .then( (response) => {


        console.log( "Aqui tenemos la respuesta") ;

        console.log( response.data ) ;

        //setMyData( response.data ) ;
        if ( response.data.length > 0 )
        {
            //setShowDrop( true ) ;

            var arr = [] ;

            for( var i = 0 ; i < response.data.length ; i++)
            {
                var obj = {} ;
                obj.id = response.data[i].idcasesatcodigo  ; // idcasesatcodigo // idcasesatcodigo
                obj.field1 = response.data[i].codigo ;
                obj.field3 = response.data[i].nombre ;  
                obj.field2 = "Marketing Director" ;
                obj.field4 = response.data[i].codigo ;
                obj.field5 = "Creado por Charly" ;
                obj.field6 = "2024-02-11 17:01:02" ;
                obj.naturaleza =  response.data[i].naturaleza ;     
                
                
                arr.push( obj ) ;

            }

            setCards( arr ) ;

        }
        else{
            //setShowDrop ( false ) ;
        }
        

    } ) 
    .catch( ( err ) => {

        console.log( "Tenemos un error")
        console.log( err ) ;
    })



  }

    function theSelectedFirst( index )
    {
        console.log( "theSelectedFirst Se selecciono el index(1) = " + JSON.stringify( cards[index] ) ) ;

        setSelected( cards[index] )

        theCode( cards[index].field1 )


        axios.get(  "http://localhost:3004/livefactura/getGrupoFirst/?code=" + cards[index].field1 )
        .then((response) => {
            console.log( "response(1) = " +  response.data  ) ;

            if ( response.data[0].length === 0 )
            {
                return ;
            }

            console.log( "casegroup  = " + JSON.stringify( response.data[0].idcatcasegroup ) ) ;


            if ( response.data.length > 0 )
            {
                //setShowDrop( true ) ;
    
                var arr = [] ;
    
                for( var i = 0 ; i < response.data.length ; i++)
                {
                    console.log( "Codigo = " + response.data[i].name ) ;

                    var obj = {} ;
                    obj.id = response.data[i].idcasesatcodigo  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response.data[i].cuenta ;
                    obj.field3 = response.data[i].name ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = response.data[i].comentario ;
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 = "2024-02-11 17:01:02" ;   
                    obj.idcatcasegroup = response.data[i].idcatcasegroup ;  
                    
                    
                    arr.push( obj ) ;
    
                }
    

                theCards( arr ) ;
    
            }
            else{
                //setShowDrop ( false ) ;
            }
    


        })
        .catch( (err) => {
            console.log( err) ;
        })



    }

    useEffect(()  => {

        console.log( "lastCode *** = " + lastCode )

    } , [lastCode])

    function theSelected( index )
    {
        console.log( "Se selecciono el index(1***) = " + JSON.stringify( cards[index] ) ) ;


        var myCode = cards[index].field1 ;
    

        console.log( "code = " + cards[index].field1 )

        if ( cards[index].field1 === ( lastCode.replace( "-" , " ") ) )
        {
            if ( lastCode.indexOf('-') >=0 )
            {
                myCode = cards[index].field1 ;

            }
            else{

                myCode = '-' + myCode ;


            }
        }


        console.log( "Cambiando codigo(2)")
        setlastCode( myCode ) ;

        setSelected( cards[index] )


        console.log( "lastCode = " + lastCode ) ;
        console.log( "myCode = " + myCode ) ;

        theCode( myCode ) ; // cards[index].field1


        return ;

//app.get('/livefactura/getsecond', async function(req, res){
    //  
//        axios.get(  "http://localhost:3004/livefactura/getGrupo/?code=" + cards[index].field1 )
        axios.get(  "http://localhost:3004/livefactura/getSecondLength/?code=" + cards[index].field1 + "&len=1")
        .then((response) => {
            console.log( "response(1) getSecond = " + JSON.stringify( response.data ) ) ;

            if ( response.data[0].length === 0 )
            {
                return ;
            }

            console.log( "casegroup  = " + JSON.stringify( response.data[0].idcatcasegroup ) ) ;


            if ( response.data.length > 0 )
            {
                //setShowDrop( true ) ;
    
                var arr = [] ;
    
                for( var i = 0 ; i < response.data.length ; i++)
                {
                    console.log( "Codigo = " + response.data[i].name ) ;

                    var obj = {} ;
                    obj.id = response.data[i].idcasesatcodigo  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response.data[i].parent ;
                    obj.field3 = response.data[i].second ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = response.data[i].name ;
                    obj.field5 = response.data[i].comment ;
                    obj.field6 = "2024-02-11 17:01:02" ;   
                    obj.idcatcasegroup = response.data[i].idcatcasegroup ;  
                    
                    
                    arr.push( obj ) ;
    
                }
    

                theCards( arr ) ;
    
            }
            else{
                //setShowDrop ( false ) ;
            }
    


        })
        .catch( (err) => {
            console.log( err) ;
        })
    }

  return (
    
        <>
            <div style={{overflowY:'auto' , overflowX :'hidden', height : '90%'}}>

                {

                    cards.map( (data,index) =>
                        <DoCaseCard00 data={data} naturaleza={data.naturaleza} 
                            index={index} selected={theSelected}></DoCaseCard00>
                    )


                }
                
                {/* <DoCasePlus type={'group'}></DoCasePlus> */}

            </div>

            

        </>

  )
}

export default DoCase00